<template>
    <div v-bind="$attrs" class="wrapper" ref="wrapper">
        <div class="shadow-wrapper shadow-wrapper-top">
            <div class="shadow shadow-top" ref="shadowTop" :style="`opacity: ${shadowTopOpacity};`"/>
        </div>
        <slot />
        <div class="shadow-wrapper shadow-wrapper-bottom">
            <div class="shadow shadow-bottom" ref="shadowBottom" :style="`opacity: ${shadowBottomOpacity};`"/>
        </div>
    </div>
</template>

<script>
import {onMounted, onUnmounted, ref} from "@vue/composition-api";

export default {
    name: "ScrollShadow",
    setup() {
        const wrapper = ref(null)
        const shadowTopOpacity = ref(0)
        const shadowBottomOpacity = ref(0)
        const currentScrollTop = ref(0)

        const calculateScroll = async () => {
            currentScrollTop.value = wrapper.value.scrollTop

            const scrollHeight = wrapper.value.scrollHeight - wrapper.value.offsetHeight
            const currentScroll = wrapper.value.scrollTop / scrollHeight

            shadowTopOpacity.value = scrollHeight !== 0 ? currentScroll : 0
            shadowBottomOpacity.value = scrollHeight !== 0 ? 1 - currentScroll : 0
        }

        onMounted(() => {
            new ResizeObserver(async () => {
                await calculateScroll()
            }).observe(wrapper.value)
            wrapper.value.addEventListener('scroll', calculateScroll)

            calculateScroll()
        })

        onUnmounted(() => {
            wrapper.value.removeEventListener('scroll', calculateScroll)
        })

        return {
            wrapper,
            shadowTopOpacity,
            shadowBottomOpacity,
            currentScrollTop,
        }
    }
}
</script>

<style scoped lang="scss">
.wrapper {
    position: relative;
    overflow-y: auto;
    flex-grow: 1;
}

.shadow-wrapper {
    position: sticky;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100%;
    pointer-events: none
}

.shadow {
    position: absolute;
    left: 0;
    right: 0;
    min-height: 10px;
}

.shadow-wrapper-top {
    top: 0;
}

.shadow-wrapper-bottom {
    bottom: 0;
}

.shadow-top {
    background: -webkit-linear-gradient(270deg, rgba(0, 0, 0, 0.2), transparent);
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.2), transparent);
    opacity: 0;
    top: 0;
}

.shadow-bottom {
    opacity: 0;
    bottom: 0;
    background: -webkit-linear-gradient(90deg, rgba(0, 0, 0, 0.2), transparent);
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), transparent);
}

</style>